import { useTheme } from "../contexts/ThemeContext";
import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";

interface ThemeToggleProps {
  size?: "sm" | "md";
}

export default function ThemeToggle({ size = "md" }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();

  const iconSize = size === "sm" ? "w-4 h-4" : "w-5 h-5";
  const btnSize = size === "sm" ? "w-8 h-8" : "p-2 sm:p-2.5";

  return (
    <button
      onClick={toggleTheme}
      className={`${btnSize} relative rounded-lg hover:bg-muted transition-all cursor-pointer flex items-center justify-center overflow-hidden`}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      <motion.div
        key={theme}
        initial={{ y: -20, opacity: 0, rotate: -90 }}
        animate={{ y: 0, opacity: 1, rotate: 0 }}
        exit={{ y: 20, opacity: 0, rotate: 90 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        {theme === "dark" ? (
          <Sun className={`${iconSize} text-yellow-400`} />
        ) : (
          <Moon className={`${iconSize} text-indigo-500`} />
        )}
      </motion.div>
    </button>
  );
}
